import { AfterViewInit, Component, Inject, OnDestroy, OnInit, Optional, HostListener, ViewChild, ElementRef } from '@angular/core';

import { FormArray, FormBuilder, FormControl, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

import Swal from 'sweetalert2';
import { MatChipInputEvent } from '@angular/material/chips';
import { COMMA, ENTER } from '@angular/cdk/keycodes';
import validator from 'validator';
import { ToastrService } from 'ngx-toastr';
import { ActivatedRoute } from '@angular/router';
import { UserService } from '../services/user.service';
import { AssignmentService } from '../services/assignment.service';
import { LanguageService } from 'src/app/services/language.service';
import { HttpClient } from '@angular/common/http';
import { Handle, SliderRange } from '../shared/components/custom-slider/custom-slider.component';
import { TranslateService } from '@ngx-translate/core';


@Component({
   selector: 'app-assignment-configuration',
   templateUrl: './assignment-configuration.component.html',
   styleUrls: ['./assignment-configuration.component.scss']
})

export class AssignmentConfigurationComponent implements OnInit, AfterViewInit {
   assignmentForm;
   separatorKeysCodes: number[] = [ENTER, COMMA];
   includeUrlsArray: string[] = [];
   excludeUrlsArray: string[] = [];
   currentUser: any;
   subjects;
   isNew: boolean = true;
   fontFamilies = [];
   settings: any;
   languages = [
      {
         text: 'English',
         value: 'en',
         selectedDocLanguage: false,
         selectedTranslateLanguage: false,
      },
      {
         text: 'Albanian',
         value: 'sq',
         selectedDocLanguage: false,
         selectedTranslateLanguage: false,
      },
      {
         text: 'German',
         value: 'de',
         selectedDocLanguage: false,
         selectedTranslateLanguage: false,
      },
      {
         text: 'Italian',
         value: 'it',
         selectedDocLanguage: false,
         selectedTranslateLanguage: false,
      },
      {
         text: 'French',
         value: 'fr',
         selectedDocLanguage: false,
         selectedTranslateLanguage: false,
      },
      {
         text: 'Spanish',
         value: 'es',
         selectedDocLanguage: false,
         selectedTranslateLanguage: false,
      },
      {
         text: 'Greek',
         value: 'el',
         selectedDocLanguage: false,
         selectedTranslateLanguage: false,
      },
      {
         text: 'Czech',
         value: 'cs',
         selectedDocLanguage: false,
         selectedTranslateLanguage: false,
      },
      {
         text: 'Turkish',
         value: 'tr',
         selectedDocLanguage: false,
         selectedTranslateLanguage: false,
      },
      {
         text: 'Slovak',
         value: 'sk',
         selectedDocLanguage: false,
         selectedTranslateLanguage: false,
      },
      {
         text: 'Lithuanian',
         value: 'lt',
         selectedDocLanguage: false,
         selectedTranslateLanguage: false,
      },
      {
         text: 'Latvian',
         value: 'lv',
         selectedDocLanguage: false,
         selectedTranslateLanguage: false,
      },
      {
         text: 'Polish',
         value: 'pl',
         selectedDocLanguage: false,
         selectedTranslateLanguage: false,
      },
      {
         text: 'Serbian',
         value: 'sr',
         selectedDocLanguage: false,
         selectedTranslateLanguage: false,
      },
      {
         text: 'Macedonian',
         value: 'mk',
         selectedDocLanguage: false,
         selectedTranslateLanguage: false,
      },
      {
         text: 'Portuguese',
         value: 'pt',
         selectedDocLanguage: false,
         selectedTranslateLanguage: false,
      },
      {
         text: 'Dutch',
         value: 'nl',
         selectedDocLanguage: false,
         selectedTranslateLanguage: false,
      },
      {
         text: 'Russian',
         value: 'ru',
         selectedDocLanguage: false,
         selectedTranslateLanguage: false,
      },
      {
         text: 'Bulgarian',
         value: 'bg',
         selectedDocLanguage: false,
         selectedTranslateLanguage: false,
      },
      {
         text: 'Hungarian',
         value: 'hu',
         selectedDocLanguage: false,
         selectedTranslateLanguage: false,
      },
      {
         text: 'Romanian',
         value: 'ro',
         selectedDocLanguage: false,
         selectedTranslateLanguage: false,
      },
      {
         text: 'Slovenian',
         value: 'sl',
         selectedDocLanguage: false,
         selectedTranslateLanguage: false,
      },
      {
         text: 'Swedish',
         value: 'sv',
         selectedDocLanguage: false,
         selectedTranslateLanguage: false,
      },
      {
         text: 'Finnish',
         value: 'fi',
         selectedDocLanguage: false,
         selectedTranslateLanguage: false,
      },
      {
         text: 'Croatian',
         value: 'hr',
         selectedDocLanguage: false,
         selectedTranslateLanguage: false,
      },
      {
         text: 'Bosnian',
         value: 'bs',
         selectedDocLanguage: false,
         selectedTranslateLanguage: false,
      },
      {
         text: 'Norwegian',
         value: 'no',
         selectedDocLanguage: false,
         selectedTranslateLanguage: false,
      },
      {
         text: 'Danish',
         value: 'da',
         selectedDocLanguage: false,
         selectedTranslateLanguage: false,
      },
      {
         text: 'Estonian',
         value: 'et',
         selectedDocLanguage: false,
         selectedTranslateLanguage: false,
      }
   ];
   getCurrentUser$: any;
   getSubjectsStateDetails$: any;
   getAssignmentsStateDetails$: any;
   submitClicked = false;
   translatedLanguageEnabled = new FormControl(false);
   selectedTranslatedLanguages = new FormControl([], [Validators.maxLength(3)]);
   additionalSettings = false;
   userId: any;
   assignmentId: any;
   assignmentData: any;
   dataLoaded: boolean = false;

   // Slider configuration for thresholds
   @ViewChild('sliderTrack') sliderTrack: ElementRef;
   similarityHandles: Handle[] = [
      { value: 60, min: 40, max: 90 },
      { value: 80, min: 60, max: 90 }
   ];
   similarityDefaultValues = [60, 80];

   translationHandles: Handle[] = [
      { value: 50, min: 0, max: 50, hardMinimum: 50 },
      { value: 80, min: 50, max: 95 }
   ];
   translationDefaultValues = [50, 80];

   similarityRangeColors: SliderRange[] = [
      { color: '#BCBCBC', label: 'Below Threshold' },
      { color: '#7ABDFF', label: 'Altered Text' },
      { color: '#F386AB', label: 'Exact Match' }
   ];

   translationRangeColors: SliderRange[] = [
      { color: '#D9D9D9', label: '' },
      { color: '#BCBCBC', label: '' },
      { color: '#FED27C', label: 'Contextual Similarity' }
   ];
   constructor(
      private fb: FormBuilder,
      @Optional() @Inject(MAT_DIALOG_DATA) public data: any,
      @Optional() public dialogRef: MatDialogRef<any>,
      private toastrService: ToastrService,
      private route: ActivatedRoute,
      private userService: UserService,
      private assignmentService: AssignmentService,
      private languageService: LanguageService,
      private http: HttpClient,
      private translate: TranslateService
   ) { }

   ngAfterViewInit(): void {
      setTimeout(() => {
         this.assignmentForm.valueChanges.subscribe((formValues) => {
            this.onFormChange(formValues);
         });
      }, 4000);
   }

   ngOnInit(): void {
      this.userId = this.route.snapshot.paramMap.get('userId');
      this.assignmentId = this.route.snapshot.paramMap.get('assignmentId');

      // Handle test route without parameters
      if (!this.userId || !this.assignmentId) {
         this.initializeTestMode();
         return;
      }

      this.assignmentForm = this.fb.group({
         type: [1],
         translatedLanguage: this.selectedTranslatedLanguages,
         aiDetection: [false],
         archive: [true],
         anonymous_submissions: [false],
         exclude_citations: [false],
         submission_word_limit: [0],
         source_percentage_threshold: [0],
         sources: this.fb.group({
            includeSources: this.fb.array([]),
            excludeSources: this.fb.array([])
         }),
         contextualSimilarity: [false],
         contextualSimilaritiesThreshold: [80, [Validators.max(100), Validators.min(50)]],
         // Additional form controls from professor-create-assignment
         fontFamily: [''],
         metadataAnalysis: [false],
         lateSubmissions: [false],
         lateSubmissionsDate: [''],
         reSubmissions: [false],
         nrReSubmissions: [1],
         enableThresholds: [false],
         exactMatchThreshold: [this.similarityHandles[1].value],
         alteredTextThreshold: [this.similarityHandles[0].value]
      });

      this.route.params.subscribe(params => {
         let userData;
         let token;
         userData = JSON.parse(params['userData'])
         token = JSON.parse(params['userData']).token
         localStorage.setItem('ACCESS_TOKEN', JSON.stringify(token));
         localStorage.setItem('role', JSON.stringify(userData.roleId));
         localStorage.setItem('user', JSON.stringify(userData));
         localStorage.setItem('websiteLanguage', userData.language);

         this.languageService.setSelectedLanguage(userData.language);


         // Load fonts
         this.loadFonts();

         this.userService.userInfo(this.userId).subscribe(response => {
            console.log('response', response.user);
            this.currentUser = response.user;
            this.settings = this.currentUser?.Institution?.InstitutionSettings[0];
            console.log('currentUser', this.currentUser)
            this.assignmentService.getAssignment(this.assignmentId).subscribe((data) => {
               console.log('Assignment data', data);
               this.assignmentData = data;

               // Start patching the form (during initialization)
               this.assignmentForm.controls['type'].setValue(data.type);
               this.assignmentForm.controls['translatedLanguage'].setValue(JSON.parse(data.translatedLanguage));
               this.assignmentForm.controls['aiDetection'].setValue(data.aiDetection || false);
               this.assignmentForm.controls['archive'].setValue(data.archive || false);
               this.assignmentForm.controls['anonymous_submissions'].setValue(data.anonymous_submissions || false);
               this.assignmentForm.controls['exclude_citations'].setValue(data.exclude_citations || false);
               this.assignmentForm.controls['source_percentage_threshold'].setValue(data.source_percentage_threshold || 0);
               this.assignmentForm.controls['contextualSimilarity'].setValue(data.context_similarity);
               this.assignmentForm.controls['contextualSimilaritiesThreshold'].setValue(data.sentence_thresholds?.contextualSimilaritiesThreshold || 80);

               // Additional form fields
               this.assignmentForm.controls['fontFamily'].setValue(data.fontFamily || data.typography || '');
               this.assignmentForm.controls['metadataAnalysis'].setValue(data.metadataAnalysis || false);
               this.assignmentForm.controls['submission_word_limit'].setValue(data.submission_word_limit || 0);

               // Late submissions
               if (data.lateSubmissions) {
                  this.assignmentForm.controls['lateSubmissions'].setValue(true);
                  this.assignmentForm.controls['lateSubmissionsDate'].setValue(new Date(data.lateSubmissions));
               }

               // Resubmissions
               if (data.numberOfReSubmisions && data.numberOfReSubmisions > 0) {
                  this.assignmentForm.controls['reSubmissions'].setValue(true);
                  this.assignmentForm.controls['nrReSubmissions'].setValue(data.numberOfReSubmisions);
               }

               // Threshold settings
               if (data.sentence_thresholds) {
                  this.assignmentForm.controls['alteredTextThreshold'].setValue(data.sentence_thresholds.alteredTextThreshold || 60);
                  this.assignmentForm.controls['exactMatchThreshold'].setValue(data.sentence_thresholds.exactMatchThreshold || 80);

                  // Update slider handles
                  if (this.settings?.enableSimilarityThresholdsEdit) {
                     this.similarityHandles[0].value = data.sentence_thresholds.alteredTextThreshold || 60;
                     this.similarityHandles[1].value = data.sentence_thresholds.exactMatchThreshold || 80;
                  }

                  if (this.settings?.enableContextualSimilarity) {
                     this.translationHandles[1].value = data.sentence_thresholds.contextualSimilaritiesThreshold || 80;
                  }
               }

               // Handle sources
               this.includeUrlsArray = data.sources?.includeSources || [];
               this.excludeUrlsArray = data.sources?.excludeSources || [];

               // Update FormArrays
               this.updateFormArray('includeSources', this.includeUrlsArray);
               this.updateFormArray('excludeSources', this.excludeUrlsArray);

               // Set the translated language toggle
               this.translatedLanguageEnabled.setValue(JSON.parse(data.translatedLanguage)?.length > 0);

               this.dataLoaded = true;
            });
         });

      });
      console.log('this.userId', this.userId)
      console.log('this.assignmentId', this.assignmentId)

      this.languages.sort((a, b) => a.text.localeCompare(b.text));

      if (this.data !== undefined && this.data !== null) {
         this.isNew = this.data.isNew;
      }

      this.translatedLanguageEnabled.valueChanges.subscribe((enabled) => {
         if (!enabled) {
            this.selectedTranslatedLanguages.setValue([]);
         }
      });
   }

   isSelected(language: string): boolean {
      return this.selectedTranslatedLanguages.value.includes(language);
   }

   selectTranslatedLanguage(event) {
      this.selectedTranslatedLanguages = event.value;
      this.form.translatedLanguage.setValue(this.selectedTranslatedLanguages);
   }


   addUrl(event: MatChipInputEvent, type: string): void {
      const input = event.input;
      const value = event.value;

      if (value?.trim()) {
         if (validator.isURL(value, { require_protocol: false })) {
            if (type === 'include') {
               this.includeUrlsArray.push(value.trim());
               this.updateFormArray('includeSources', this.includeUrlsArray);
            } else if (type === 'exclude') {
               this.excludeUrlsArray.push(value.trim());
               this.updateFormArray('excludeSources', this.excludeUrlsArray);
            }
         } else {
            this.toastrService.error(`Invalid URL: ${value}`);
         }
      }

      if (input) {
         input.value = '';
      }
   }

   removeUrl(index: number, type: string): void {
      if (type === 'include') {
         this.includeUrlsArray.splice(index, 1);
         this.updateFormArray('includeSources', this.includeUrlsArray);
      } else if (type === 'exclude') {
         this.excludeUrlsArray.splice(index, 1);
         this.updateFormArray('excludeSources', this.excludeUrlsArray);
      }
   }
   /**
    * Method used to get controls from formGroup
    */
   get form() {
      return this.assignmentForm.controls;
   }

   async createAssignment() {
      this.submitClicked = true;

      if (this.translatedLanguageEnabled.value && (!this.selectedTranslatedLanguages.value || this.selectedTranslatedLanguages.value.length === 0)) {
         this.toastrService.error('Please select at least one translated language.');
         return;
      }

      if (this.assignmentForm.invalid || !this.validateThresholds()) {
         console.log('Form validation errors:', this.assignmentForm.errors);
         return;
      }

      const result = await Swal.fire({
         title: this.translate.instant('app.confirm_create_of_assignment'),
         icon: 'warning',
         showCancelButton: true,
         confirmButtonColor: '#3085d6',
         cancelButtonColor: '#b5adad',
         confirmButtonText: this.translate.instant('app.confirm'),
      });
      if (result.isConfirmed) {
         this.submitClicked = false;
         if (this.isNew) {
         } else {

            this.includeUrlsArray = [];
            this.excludeUrlsArray = [];
            this.assignmentForm.controls.sources.get('includeSources').setValue([]);
            this.assignmentForm.controls.sources.get('excludeSources').setValue([]);
            this.dialogRef.close();
         }
      }
   }

   languageSelected(type) {
      if (type === 1) {
         for (let language of this.languages) {
            language.selectedDocLanguage = false;

            if (language.value === this.form.originalLanguage.value) {
               language.selectedDocLanguage = true;
            }
         }
         if (!this.form.translatedLanguage.value) {
            this.form.translatedLanguage.setValue('0');
         }
      } else {
         for (let language of this.languages) {
            language.selectedTranslateLanguage = false;
            if (language.value === this.form.translatedLanguage.value) {
               language.selectedTranslateLanguage = true;
            }
         }
      }
   }

   isValid(field) {
      return (field.invalid && field.touched) || (field.invalid && this.submitClicked);
   }

   openLink(url: string) {
      window.open(url, '_blank');
   }

   toggleAdditionalSettings() {
      this.additionalSettings = !this.additionalSettings;
   }

   onFormChange(formValues: any) {
      console.log('Form changed:', formValues);
      formValues.startDate = this.assignmentData.startDate;
      formValues.endDate = this.assignmentData.endDate;
      formValues.description = this.assignmentData.description;
      formValues.name = this.assignmentData.name;
      formValues.numberOfReSubmisions = this.assignmentData.numberOfReSubmisions;
      this.assignmentService.editAssignment(formValues, this.assignmentId).subscribe((data) => {
         console.log(data);
      });
   }

   updateFormArray(controlName: string, values: string[]) {
      const formArray = this.assignmentForm.get('sources').get(controlName) as FormArray;
      formArray.clear();
      values.forEach(value => formArray.push(this.fb.control(value)));
   }

   // Additional methods from professor-create-assignment
   loadFonts(): void {
      this.http.get<string[]>('assets/fonts.json').subscribe(
         (data) => {
            this.fontFamilies = data;
         },
         (error) => {
            console.error('Error loading fonts:', error);
         }
      );
   }

   resetDate() {
      this.assignmentForm.controls.lateSubmissionsDate.reset();
   }

   toggleLateSubmissions() {
      const currentValue = this.form.lateSubmissions.value;
      this.assignmentForm.patchValue({ lateSubmissions: !currentValue });
      if (!currentValue) {
         // If enabling late submissions, don't reset the date
      } else {
         // If disabling late submissions, reset the date
         this.resetDate();
      }
   }

   resetSubmissionsNr() {
      this.assignmentForm.controls.nrReSubmissions.reset();
   }

   onSimilarityHandleChange(handles: Handle[]) {
      this.similarityHandles = [...handles];

      // Update form controls with new values
      this.assignmentForm.patchValue({
         alteredTextThreshold: handles[0].value,
         exactMatchThreshold: handles[1].value
      }, { emitEvent: false });
   }

   onTranslationHandleChange(handles: Handle[]) {
      this.translationHandles = [...handles];

      // Update form control with new value
      this.assignmentForm.patchValue({
         contextualSimilaritiesThreshold: handles[1].value
      }, { emitEvent: false });
   }

   private validateThresholds(): boolean {
      if (this.assignmentForm.get('enableThresholds')?.value) {
         const alteredThreshold = this.assignmentForm.get('alteredTextThreshold')?.value;
         const exactThreshold = this.assignmentForm.get('exactMatchThreshold')?.value;
         const contextualThreshold = this.assignmentForm.get('contextualSimilaritiesThreshold')?.value;

         // Validate that values are within expected ranges
         if (alteredThreshold < 0 || alteredThreshold > 100 ||
            exactThreshold < 0 || exactThreshold > 100 ||
            contextualThreshold < 50 || contextualThreshold > 100) {
            this.toastrService.error('Invalid threshold values');
            return false;
         }

         // Validate that altered threshold is less than exact threshold
         if (alteredThreshold >= exactThreshold) {
            this.toastrService.error('Altered text threshold must be less than exact match threshold');
            return false;
         }
      }
      return true;
   }

   initializeTestMode(): void {
      // Load fonts for test mode
      this.loadFonts();

      // Initialize form with default values
      this.assignmentForm = this.fb.group({
         type: [1],
         translatedLanguage: this.selectedTranslatedLanguages,
         aiDetection: [false],
         archive: [true],
         anonymous_submissions: [false],
         exclude_citations: [false],
         submission_word_limit: [0],
         source_percentage_threshold: [0],
         sources: this.fb.group({
            includeSources: this.fb.array([]),
            excludeSources: this.fb.array([])
         }),
         contextualSimilarity: [false],
         contextualSimilaritiesThreshold: [80, [Validators.max(100), Validators.min(50)]],
         fontFamily: [''],
         metadataAnalysis: [false],
         lateSubmissions: [false],
         lateSubmissionsDate: [''],
         reSubmissions: [false],
         nrReSubmissions: [1],
         enableThresholds: [false],
         exactMatchThreshold: [this.similarityHandles[1].value],
         alteredTextThreshold: [this.similarityHandles[0].value]
      });

      // Set up mock current user and settings for testing
      this.currentUser = {
         Institution: {
            InstitutionSettings: [{
               enableAiDetection: true,
               enableMetadataAnalysis: true,
               enableArchiveDocuments: true,
               enableSimilarityThresholdsEdit: true,
               enableContextualSimilarity: true,
               source_percentage_threshold: 5,
               submission_word_limit: 100
            }]
         }
      };
      this.settings = this.currentUser.Institution.InstitutionSettings[0];

      // Sort languages
      this.languages.sort((a, b) => a.text.localeCompare(b.text));

      // Set up translation toggle listener
      this.translatedLanguageEnabled.valueChanges.subscribe((enabled) => {
         if (!enabled) {
            this.selectedTranslatedLanguages.setValue([]);
         }
      });

      // Mark as loaded
      this.dataLoaded = true;
   }
}
